import { Form } from "reactstrap";
import { Btn, P } from "../../../../../AbstractElements";
import { productGalleryData } from "../../../../../Data/AppsData/EcommerceData/ProductData";
import { ActiveCallbackProp } from "../../../../../Types/EcommerceType";
import CommonFileUpload from "../../../../../Utils/CommonComponents/CommonFileUpload";
import SvgIcon from "../../../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import { Next, Previous } from "../../../../../Utils/Constants";

export default function ProductGallery({ activeCallBack }: ActiveCallbackProp) {
  return (
    <div className="sidebar-body">
      {productGalleryData.map((item) => (
        <div key={item.id} className="product-upload">
          <P>{item.title} </P>
          <Form>
            <CommonFileUpload />
          </Form>
        </div>
      ))}
      <div className="product-buttons">
        <Btn color="transparent" className="me-1" onClick={() => activeCallBack(1)}>
          <div className="d-flex align-items-center gap-sm-2 gap-1">
            <SvgIcon iconId="back-arrow" /> {Previous}
          </div>
        </Btn>
        <Btn color="transparent" onClick={() => activeCallBack(3)}>
          <div className="d-flex align-items-center gap-sm-2 gap-1">
            <SvgIcon iconId="front-arrow" /> {Next}
          </div>
        </Btn>
      </div>
    </div>
  );
}
